<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form inline class="inline-form">
          <el-form-item label="创建时间">
            <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange" type="daterange" :disabledAfterDate="new Date().getTime()"></date-range-picker>
          </el-form-item>
          <el-form-item label="打款单号">
            <el-input
              class="search-input"
              v-model="billId"
              placeholder="打款单号"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-select
              class="search-input"
              v-model="merchantId"
              placeholder="模糊搜索"
              clearable
              filterable
              remote
              :remote-method="handleMerchantInfoRemote"
              :loading="selectLoading">
              <el-option
                v-for="item in subMerchantNamesList"
                :key="item.fmerchantId"
                :label="item.fmerchantId"
                :value="item.fmerchantId">
                <span class="value">{{ item.fmerchantId }}</span>
                <span class="name">{{ item.fmerchantName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="直属代理商">
            <el-select
              class="search-input"
              v-model="subAgentId"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleAgentInfoFilter">
              <el-option
                v-for="item in subAgentInfoList"
                :key="item.fAgentId"
                :label="item.fAgentId"
                :value="item.fAgentId">
                <span class="value">{{ item.fAgentId }}</span>
                <span class="name">{{ item.fTitle }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发展业务员">
            <el-select
              class="search-input"
              v-model="operatorAccount"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleSalesInfoFilter"
              :disabled="roleName == 'operator'">
              <el-option
                v-for="(item, index) in saleInfoList"
                :key="index"
                :label="item.fAgentAccount"
                :value="item.fAgentAccount">
                <span class="value">{{ item.fAgentAccount }}</span>
                <span class="name">{{ item.fName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="打款状态">
            <el-select style="width: 120px;" v-model="state" clearable>
              <el-option label="打款失败" value="-1"></el-option>
              <el-option label="打款中" value="0"></el-option>
              <el-option label="打款成功" value="1"></el-option>
              <el-option label="打款退票" value="2" v-if="payBillFlag === '1'"></el-option>
              <el-option label="冻结出款" value="3" v-if="payBillFlag === '1'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="打款类型">
            <el-select style="width: 130px;" v-model="payBillFlag" @change="state = '';profitType = ''">
              <el-option label="D0" value="0"></el-option>
              <el-option label="D1" value="1"></el-option>
              <el-option label="D1（合并）" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提现类型" v-show="payBillFlag === '2'">
            <el-select style="width: 120px;" v-model="profitType" clearable>
              <el-option label="分时结算" :value="4"></el-option>
              <el-option label="分账结算" :value="17"></el-option>
              <el-option label="补贴结算" :value="11"></el-option>
              <el-option label="合并结算" :value="15"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
            <auth-button
              icon="el-icon-download"
              opt="export"
              :plain="true"
              :loading="exportButtonLoading"
              @click.native="exportClick"
              label="导出"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <div class="search-tips">
          说明：<br>
          1、目前只展示近期1个月的所有打款订单，和累积所有打款失败订单；<br>
          2、打款类型分为D0/D1/D1合并，打款单改造(2020/6/9)后原D1合并的打款数据（包括返佣结算/分时结算/分账结算等）统一在D1中查看；<br>
          3、导出最大支持100000条数据。
        </div>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="paybillList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fcreateTime"
          label="创建时间"
          align="center">
          <!-- :formatter='formatDate' -->
        </el-table-column>
        <el-table-column
          prop="fbillId"
          label="打款单号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fmerchantId"
          label="商户编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户简称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="amountStr"
          label="实际打款金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="stateStr"
          label="打款状态"
          align="center">
          <!-- <template slot-scope="scope">
                <div>{{ scope.row.F_state | formatFState }}</div>
              </template> -->
        </el-table-column>
        <el-table-column
          prop="profitTypeStr"
          label="提现类型"
          v-if="payBillFlag === '2'"
          align="center"></el-table-column>
        <el-table-column
          prop="fremark"
          label="备注"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fupdateTime"
          label="更新时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fbankHolder"
          label="银行开户名"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fbankName"
          label="银行名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fbankAccount"
          label="开户账号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="直属代理商"
          align="center">
        </el-table-column>
        <el-table-column
          prop="operatorAccount"
          label="发展业务员"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <span>
              <auth-button opt="details" type="text" v-if="scope.row.paybillDetailFlag === 1" @click.native="showDetailInfo(scope.row)" label="查看详情"></auth-button>
            </span>
            <span>
              <auth-button opt="settle_card_edit" type="text" @click.native="changeBankCardButtonClick(scope.$index, scope.row)" label="修改结算卡"></auth-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
    <el-dialog
      title="打款详情"
      :visible.sync="detailInfoVisible"
      @close="clearInfo"
      width="30%">
      <div class="mgb15">打款单号 <span class="mgl30">{{ detailInfo.billId }}</span></div>
      <div class="mgb15">实际打款金额 <span class="mgl30">{{ detailInfo.amountStr }}元</span></div>
      <div class="mgb15">款项明细</div>
      <el-table
        border
        :data="detailInfo.payDetailList"
        :span-method="objectSpanMethod"
        style="width: 100%">
        <el-table-column prop="type" align="center" label=""/>
        <el-table-column
          prop="payDetail"
          align="center"
          label="款项类型">
        </el-table-column>
        <el-table-column
          prop="number"
          align="center"
          label="金额（元）">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { exportMerchantPaybill, lookUpDetailInfo, listAgentMerchant, listPaybill } from '@/api/settle'
import { subAgentInfo, queryAllSale } from '@/api/merchant'
export default {
  name: 'AgentPaymentRecode',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10)
    const toadyZero = new Date(new Date().setMonth(new Date().getMonth() - 6)).setDate(1)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10)
    return {
      loading: false,
      detailInfoVisible: false,
      transDetailList: [],
      transferList: [],
      detailInfo: {
        billId: '',
        amountStr: '',
        payDetailList: []
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        agentId: '',
        operatorAccount: '',
        merchantId: '',
        payType: '',
        state: '',
        profitType: ''
      },
      creatTime: [todayZeroStr, todayStr],
      subAgentId: '',
      operatorAccount: '',
      merchantId: '',
      merchantName: '',
      billId: '',
      payBillFlag: '1',
      state: '-1',
      searchType: 0,
      tableLoading: false,
      selectLoading: false,
      exportButtonLoading: false,
      subMerchantNamesList: [],
      subAgentInfoList: [],
      subAgentInfoList_back: [],
      saleInfoList: [],
      saleInfoList_back: [],
      paybillList: [],
      profitType: ''// 提现类型筛选项
    }
  },
  mounted () {
    this.getDefaultData()
  },
  beforeDestroy () {},
  methods: {
    /**
     * @description 初始加载数据方法
     */
    async getDefaultData () {
      this.loading = true
      if (this.roleName !== 'operator') {
        await this.getSubAgentInfo()
        await this.querySaleList()
      }
      // await this.searchClick()
      this.loading = false
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick (noReset) {
      this.setSearchInfoParams(noReset)
      this.listPaybill()
    },
    /**
     * 查询类型选择change
     */
    searchTypeSelectChange (value) {
      if (value === 0) {
        this.state = '-1'
      } else {
        this.state = '1'
        // this.subAgentId = ''
        // this.operatorAccount = ''
      }
    },
    /**
     * 导出按钮点击
     */
    exportClick () {
      this.setSearchInfoParams(true)
      // const startDate = new Date(this.searchInfo.startTime)
      // const endDate = new Date(this.searchInfo.endTime)
      // if (!this.searchInfo.startTime || !this.searchInfo.endTime || endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 30) {
      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        this.$message({
          // message: '请筛选1个月内的数据进行导出',
          message: '请筛选时间进行导出',
          type: 'error'
        })
        return
      }
      this.exportMerchantPaybill()
    },
    /**
     * 组装筛选参数
     */
    setSearchInfoParams (noReset) {
      this.searchInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] + ' 00:00:00' : ''
      this.searchInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] + ' 23:59:59' : ''
      this.searchInfo.agentId = this.subAgentId || ''
      this.searchInfo.operatorAccount = this.operatorAccount || ''
      this.searchInfo.merchantId = this.merchantId.replace(/ /g, '') || ''
      this.searchInfo.payBillFlag = this.payBillFlag
      this.searchInfo.state = this.state || ''
      this.searchInfo.billId = this.billId || ''
      this.searchInfo.profitType = this.profitType || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
    },
    dateChange (value) {
      this.creatTime = value
    },
    /**
     * @description 删除提交参数中的空字段
     * @param {Object} params 搜索内容对象
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 直属代理商根据输入内容返回输入建议的方法
     * @param {String} queryString 内容字符串
     * @param {Function} cb 回调函数，接收搜索结果数据
     */
    async querySubAgentSearch (queryString, cb) {
      if (this.subAgentInfoList.length === 0) {
        await this.getSubAgentInfo()
      }
      const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
      const agentList = [{
        value: userInfo.fAgentId,
        name: userInfo.fName
      }]
      this.subAgentInfoList.forEach(element => {
        agentList.push({
          value: element.fAgentId,
          name: element.fName
        })
      })
      const results = queryString ? agentList.filter(this.createSubAgentFilter(queryString)) : agentList
      cb(results)
    },
    /**
     * @description 根据输入内容进行筛选方法
     * @param {String} queryString 内容字符串
     */
    createSubAgentFilter (queryString) {
      return (agentList) => {
        return (agentList.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1) || (agentList.name.indexOf(queryString) !== -1)
      }
    },
    /**
     * 商户信息自定义筛选方法
     */
    async handleMerchantInfoRemote (queryString) {
      if (queryString) {
        this.selectLoading = true
        await this.listAgentMerchant(queryString)
        this.selectLoading = false
      } else {
        this.subMerchantNamesList = []
      }
    },
    /**
     * 直属代理商自定义筛选方法
     */
    handleAgentInfoFilter (queryString) {
      if (queryString) {
        this.subAgentInfoList = this.subAgentInfoList_back.filter(item => {
          return item.fAgentId.toLowerCase().includes(queryString.toLowerCase()) || item.fTitle.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.subAgentInfoList = this.subAgentInfoList_back
      }
    },
    /**
     * 业务员账号自定义筛选方法
     */
    handleSalesInfoFilter (queryString) {
      if (queryString) {
        this.saleInfoList = this.saleInfoList_back.filter(item => {
          return item.fAgentAccount.toLowerCase().includes(queryString.toLowerCase()) || item.fName.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.saleInfoList = this.saleInfoList_back
      }
    },
    /**
     * 修改结算卡按钮点击
     */
    changeBankCardButtonClick (index, row) {
      console.log(`修改结算卡点击 index: ${index}, row: `, row)
      // this.$router.push({ path: `/Merchant/MerchantManage/AllMerchant/${row.fmerchantId}` })
      this.$router.push({
        path: '/Merchant/MerchantManage/AllMerchant',
        query: {
          merchantId: row.fmerchantId
        }
      })
    },
    /**
     * 获取代理商下所有商户列表
     */
    listAgentMerchant (merchantId) {
      const params = qs.stringify({
        merchantName: merchantId,
        pageNo: 1,
        pageSize: 50
      })
      return new Promise((resolve, reject) => {
        listAgentMerchant(params).then(response => {
          if (parseInt(response.result_cde) === 0) {
            this.subMerchantNamesList = response.list
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.result_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
     * @description 获取下级代理商下拉列表
     */
    getSubAgentInfo () {
      return new Promise((resolve, reject) => {
        // 设一个超大的pageSize取所有数据
        subAgentInfo('pageSize=655350').then(response => {
          if (response.error_code === '0') {
            const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
            const agentList = [{
              fAgentId: userInfo.fAgentId,
              fTitle: userInfo.fTitle
            }]
            this.subAgentInfoList = agentList.concat(response.list)
            this.subAgentInfoList_back = [...this.subAgentInfoList]
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
     * 获取业务员下拉列表
     */
    querySaleList () {
      return new Promise((resolve, reject) => {
        // 设一个超大的pageSize取所有数据
        queryAllSale('pageSize=65535').then(response => {
          if (response.error_code === '0') {
            this.saleInfoList = response.list
            this.saleInfoList_back = [...this.saleInfoList]
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
     * 打款查询
     */
    listPaybill () {
      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        this.$message({
          message: '请筛选时间进行查询',
          type: 'error'
        })
        return
      }
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      listPaybill(params).then(response => {
        this.loading = false
        if (parseInt(response.result_cde) === 0) {
          this.paybillList = response.list
          this.paginations.count = response.totalCount
          if (parseInt(this.paginations.count) > 10000) {
            this.$message({
              message: '最多筛选出10000条数据，请重新筛选',
              type: 'warning'
            })
          }
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 打款查询导出
     */
    exportMerchantPaybill () {
      this.exportButtonLoading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, {
        moduleCode: 3,
        moduleName: '打款',
        menuName: '打款查询'
      }))
      exportMerchantPaybill(params).then(response => {
        this.exportButtonLoading = false
        if (parseInt(response.result_cde) === 0) {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 查看详情
     */
    showDetailInfo (row) {
      const params = qs.stringify({
        merchantId: row.fmerchantId,
        billId: row.fbillId
      })
      lookUpDetailInfo(params).then(res => {
        if (parseInt(res.result_cde) === 0) {
          this.detailInfo.billId = res.billId
          this.detailInfo.amountStr = res.amountStr
          if (res.transDetailList && res.transDetailList.length > 0) {
            this.transDetailList = res.transDetailList.map(item => {
              return {
                type: '交易明细',
                payDetail: item.sourceStr,
                number: item.amountStr
              }
            })
          }
          if (res.transferList && res.transferList.length > 0) {
            this.transferList = res.transferList.map(item => {
              return {
                type: '合并明细',
                payDetail: item.sourceStr,
                number: item.amountStr
              }
            })
          }
          const zfDetail = [{
            type: '止付明细',
            payDetail: '/',
            number: res.stopAmountStr || 0
          }]
          this.detailInfo.payDetailList = [...this.transDetailList, ...this.transferList, ...zfDetail]
          this.detailInfoVisible = true
        } else {
          this.$message({
            message: res.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 清除信息
     */
    clearInfo () {
      this.transferList = []
      this.transDetailList = []
    },
    /**
     * 合并行
     */
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      const num1 = this.transDetailList.length
      const num2 = this.transferList.length
      if (num1 > 0 && num2 > 0) {
        if (columnIndex === 0) {
          if (rowIndex === 0) {
            return [num1, 1]
          } else if (rowIndex === num1) {
            return [num2, 1]
          } else if (rowIndex === num1 + num2) {
            return [1, 1]
          } else {
            return [0, 0]
          }
        }
      }
      if (num1 > 0 && num2 === 0) {
        if (columnIndex === 0) {
          if (rowIndex === 0) {
            return [num1, 1]
          } else if (rowIndex === num1) {
            return [1, 1]
          } else {
            return [0, 0]
          }
        }
      }
      if (num2 > 0 && num1 === 0) {
        if (columnIndex === 0) {
          if (rowIndex === 0) {
            return [num2, 1]
          } else if (rowIndex === num2) {
            return [1, 1]
          } else {
            return [0, 0]
          }
        }
      }
    },
    formatDate (item) {
      return parseTime(new Date(item.fTime), '{y}-{m}-{d} {h}:{i}:{s}')
    }
  },
  computed: {
    roleName () {
      return this.$store.getters.roleName
    }
  },
  filters: {
    formatFState (value) {
      switch (value) {
        case 0:
          return '初始化状态'
        case 1:
          return '金额冻结成功'
        case 2:
          return '金额冻结失败'
        case 3:
          return '冻结结果未知'
        case 4:
          return '商户打款被冻结'
        case 5:
          return '被拦截<未发起付款>'
        case 6:
          return '打款中'
        case 14:
          return '金额解冻结果未知'
        case 15:
          return '退票成功'
        case 16:
          return '退票失败'
        case 17:
          return '退票结果未知'
        case 18:
          return '打款单被合并'
        case 19:
          return '提交打款失败，允许重新打款'
        case 20:
          return '申请退票'
        case 7:
          return '付款成功'
        case 8:
          return '付款失败'
        case 9:
          return '金额解冻转账成功'
        case 10:
          return '金额解冻转账失败'
        case 11:
          return '金额解冻转账结果未知'
        case 12:
          return '金额解冻成功'
        case 13:
          return '金额解冻失败'
      }
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.mgb15 {
  margin-bottom: 15px
}
.mgl30 {
  margin-left:30px
}
</style>
<style>
.el-dialog__body {
  padding: 20px
}
</style>
